import { homePage } from "@/mocks/home";
import ScrollReveal from "@/components/feature/ScrollReveal";

export default function HomeTagline() {
  const { tagline } = homePage;
  return (
    <ScrollReveal>
      <section className="py-16 md:py-20 bg-redbean-cream">
        <div className="mx-auto px-4 md:px-6 lg:px-8 text-center" style={{ maxWidth: "800px" }}>
          <h2
            className="font-heading font-bold text-redbean-coffee mb-6 text-balance"
            style={{ fontSize: "clamp(1.5rem, 3.5vw, 2.125rem)", lineHeight: 1.4 }}
          >
            {tagline.title}
          </h2>
          <p className="text-redbean-coffee/65" style={{ fontSize: "1.1875rem", lineHeight: 1.75 }}>
            {tagline.body}
          </p>
        </div>
      </section>
    </ScrollReveal>
  );
}